export default __webpack_public_path__ + "static/media/add-routing-intents1.985355dd.png";